export const books = [
  {
    id: 1,
    title: "جریان آب صدادار",
    author: "بورلی تان",
    img: "/img/book/shop-1-580x925.jpg",
    genre: 1,
    price: 2.7,
    date: "2020-01-01T23:28:56.782Z",
  },
  {
    id: 2,
    title: "آخرین موج دریا",
    author: "الکساندر آرونتویتز",
    img: "/img/book/shop-8-580x925.jpg",
    genre: 1,
    price: 3.2,
    date: "2019-07-21T23:28:56.782Z",
  },
  {
    id: 3,
    title: "فلورا",
    author: "رافائل مورلند",
    img: "/img/book/shop-10-580x925.jpg",
    genre: 3,
    price: 4.1,
    date: "2020-02-01T11:28:56.782Z",
  },
  {
    id: 4,
    title: "راز ها",
    author: "هری ریکتز",
    img: "/img/book/shop-21-580x925.jpg",
    genre: 3,
    price: 2.2,
    date: "2020-01-01T23:28:56.782Z",
  },
  {
    id: 5,
    title: "یک چیز خوب در هر روز",
    author: "هانتر هیلی",
    img: "/img/book/shop-20-580x925.jpg",
    genre: 2,
    price: 4.4,
    date: "2020-01-01T23:28:56.782Z",
  },
  {
    id: 6,
    title: "زندگی فردریک داگلاس",
    author: "مایا گروسمن",
    img: "/img/book/shop-17-580x925.jpg",
    genre: 3,
    price: 2.7,
    date: "2020-01-01T23:28:56.782Z",
  },
  {
    id: 7,
    title: "حیات وحش",
    author: "ادوارد اینگر",
    img: "/img/book/shop-16-580x925.jpg",
    genre: 4,
    price: 3.9,
    date: "2019-07-06T15:28:56.782Z",
  },
  {
    id: 8,
    title: "مجله غذا",
    author: "نیکولت",
    img: "/img/book/shop-12-580x925.jpg",
    genre: 5,
    price: 4.7,
    date: "2020-01-01T23:28:56.782Z",
  },
  {
    id: 9,
    title: "مینیمالیسم نام یک بازیست",
    author: "لاورنس سیگل",
    img: "/img/book/shop-1-580x925.jpg",
    genre: 3,
    price: 2.6,
    date: "2020-01-01T23:28:56.782Z",
  },
  {
    id: 10,
    title: "آموزش طراحی گرافیک",
    author: "مکدوول",
    img: "/img/book/shop-6-580x925.jpg",
    genre: 6,
    price: 2.7,
    date: "2020-01-01T23:28:56.782Z",
  },
  {
    id: 11,
    title: "زیر دره ها",
    author: "هری ریکت",
    img: "/img/book/shop-22-580x925.jpg",
    genre: 1,
    price: 3.1,
    date: "2020-01-01T23:28:56.782Z",
  },
  {
    id: 12,
    title: "زندگی شهری",
    author: "ویکتوریا جونز",
    img: "/img/book/shop-14-580x925.jpg",
    genre: 3,
    price: 4.7,
    date: "2020-01-01T23:28:56.782Z",
  },
  {
    id: 13,
    title: "مردم، پرتره ها و تصاویر",
    author: "دوروتی میچل",
    img: "/img/book/shop-2-580x925.jpg",
    genre: 2,
    price: 1.9,
    date: "2020-01-01T23:28:56.782Z",
  },
  {
    id: 14,
    title: "نقاشی دیجیتال برای طراحان گرافیک",
    author: "الینور فیتزجرالد",
    img: "/img/book/shop-3-580x925.jpg",
    genre: 2,
    price: 1.9,
    date: "2020-01-01T23:28:56.782Z",
  },
  {
    id: 15,
    title: "همه چیز در مورد استیک",
    author: "سرآشپز ایزابل مرکادو",
    img: "/img/book/shop-4-580x925.jpg",
    genre: 2,
    price: 3.9,
    date: "2020-01-01T23:28:56.782Z",
  },
  {
    id: 16,
    title: "کوه هایی که اعتقاد را می سازد",
    author: "آلفردو توررس",
    img: "/img/book/shop-5-580x925.jpg",
    genre: 2,
    price: 2.4,
    date: "2020-01-01T23:28:56.782Z",
  },
  {
    id: 17,
    title: "کتاب دعا",
    author: "جوزپین ویلیامز",
    img: "/img/book/shop-7-580x925.jpg",
    genre: 2,
    price: 1.9,
    date: "2020-01-01T23:28:56.782Z",
  },
  {
    id: 18,
    title: "فشن مینیمال برای مینیمال ها",
    author: "کیتی ری جانسون",
    img: "/img/book/shop-11-580x925.jpg",
    genre: 4,
    price: 1.9,
    date: "2020-01-01T23:28:56.782Z",
  },
  {
    id: 19,
    title: "کلاس نویسندگی",
    author: "نلی رز",
    img: "/img/book/shop-13-580x925.jpg",
    genre: 2,
    price: 3.3,
    date: "2020-01-01T23:28:56.782Z",
  },
  {
    id: 20,
    title: "پیام مخفی بازنشده",
    author: "ریچارد سانچز",
    img: "/img/book/shop-19-580x925.jpg",
    genre: 2,
    price: 4.9,
    date: "2020-01-01T23:28:56.782Z",
  },
];

export const genres = [
  { id: 1, title: "جنگی", img: "/img/genre/Action.jpg", count: 0 },
  { id: 2, title: "ماجراجویی", img: "/img/genre/Adventure.jpg", count: 0 },
  { id: 3, title: "هنر", img: "/img/genre/Art.jpg", count: 0 },
  { id: 4, title: "زندگی نامه", img: "/img/genre/Biography.jpg", count: 0 },
  { id: 5, title: "خردسالان", img: "/img/genre/Children.jpg", count: 0 },
  { id: 6, title: "فیلم نامه", img: "/img/genre/Movie.jpg", count: 0 },
  { id: 7, title: "رازآلود", img: "/img/genre/Mystery.jpg", count: 0 },
  { id: 8, title: "روانشناسی", img: "/img/genre/Relationship.jpg", count: 0 },
  { id: 9, title: "عشقی", img: "/img/genre/Romance.jpg", count: 0 },
  { id: 10, title: "علمی تخیلی", img: "/img/genre/Science.jpg", count: 0 },
  { id: 11, title: "سایر", img: "/img/genre/Other.jpg", count: 0 },
];

export const articles = [
  {
    id: 1,
    title: "الهام بخشی طبیعت",
    author: "امیر سالار سلیمانی",
    img: "/img/blog/img-01.jpg",
    date: "2020-01-09T08:16:12.782Z",
  },
  {
    id: 2,
    title: "فکر آزاد",
    author: "دکتر حسین فراهانی",
    img: "/img/blog/img-02.jpg",
    date: "2020-01-17T12:42:33.782Z",
  },
  {
    id: 3,
    title: "تاثیر ورزش بر فعالیت ها",
    author: "محسن شعبانیان",
    img: "/img/blog/img-03.jpg",
    date: "2020-02-05T09:06:02.782Z",
  },
  {
    id: 4,
    title: "هنر رقص در جوامع",
    author: "آرتور مورگان",
    img: "/img/blog/img-04.jpg",
    date: "2020-02-07T13:39:07.782Z",
  },
];

export const authors = [
  {
    id: 1,
    title: "گلشیفته فراهانی",
    img: "/img/user/profile-1t.jpg",
    count: 0,
  },
  { id: 2, title: "علی عظیمی", img: "/img/user/profile-2t.jpg", count: 0 },
  { id: 3, title: "سیمین بهبهانی", img: "/img/user/profile-3t.jpg", count: 0 },
  { id: 4, title: "سروش لشکری", img: "/img/user/profile-4t.jpg", count: 0 },
  { id: 5, title: "شاهین نجفی", img: "/img/user/profile-5t.jpg", count: 0 },
  { id: 6, title: "محسن نامجو", img: "/img/user/profile-6t.jpg", count: 0 },
];

export const chapters = [
  { id: 101, title: "فصل اول: مقدمه", free: true, book_id: 3, body: "" },
  { id: 102, title: "فصل دوم: افتتاحیه", free: false, book_id: 3, body: "" },
  { id: 103, title: "فصل سوم: اتفاق", free: false, book_id: 3, body: "" },
  { id: 104, title: "فصل چهارم: مرگ", free: false, book_id: 3, body: "" },
  { id: 105, title: "فصل پنجم: رستگاری", free: false, book_id: 3, body: "" },
];

export const subjects = [
  { id: 1, title: "خبر" },
  { id: 2, title: "نقد کتاب" },
  { id: 3, title: "آموزش" },
];

export const getBook = (id) => books.find((book) => book.id === Number(id));

export const getArticle = (id) =>
  articles.find((article) => article.id === Number(id));

export const getBookChapters = (id) => chapters;

export const getSingleChapter = (book_id, chapter_id) => {
  // get all chapter base on book id
  const chapter = chapters.find((chap) => chap.id === Number(chapter_id));
  if (!chapter) {
    return { chapter: undefined };
  }
  const chapterIndex = chapters.indexOf(chapter);
  const prev_chapter =
    chapterIndex === 0 ? undefined : chapters[chapterIndex - 1];
  const next_chapter =
    chapterIndex === chapters.length - 1
      ? undefined
      : chapters[chapterIndex + 1];
  return { chapter, prev_chapter, next_chapter };
};

export const getRandom = (arr, count) => {
  let result = new Array(count);
  let len = arr.length;
  let taken = new Array(len);
  if (count > len) {
    return arr;
  }
  while (count--) {
    let rand = Math.floor(Math.random() * len);
    result[count] = arr[rand in taken ? taken[rand] : rand];
    taken[rand] = --len in taken ? taken[len] : len;
  }
  return result;
  // const shuffled = [...array].sort(() => 0.5 - Math.random())
  // let selected = shuffled.slice(0, n);
};
